import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Users } from '@/features/users'

const usersSearchSchema = z.object({
  page: z.number().int().optional().catch(1),
  pageSize: z.number().int().optional().catch(10),
  status: z
    .array(z.enum(['active', 'inactive']))
    .optional()
    .catch([]),
  roleIds: z.array(z.number()).optional().catch([]),
  search: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/users/')({
  validateSearch: usersSearchSchema,
  component: Users,
})
